// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ReviewList_wrapper__I1tkF","insideModal":"ReviewList_insideModal__k5Mbm"};